import { render, staticRenderFns } from "./Provide.vue?vue&type=template&id=e4cbc1de&"
import script from "./Provide.vue?vue&type=script&lang=ts&"
export * from "./Provide.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports